/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Personal_Preference_HintInputs */

const en_us2_exercise_personal_preference_hint = /** @type {(inputs: Exercise_Personal_Preference_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The plan and the swaps put this first or last among equal options, never over safety or your equipment.`)
};

const pt_br2_exercise_personal_preference_hint = /** @type {(inputs: Exercise_Personal_Preference_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O plano e as trocas colocam este na frente ou por último entre opções equivalentes, sem passar por cima da segurança nem do seu equipamento.`)
};

const es_419_exercise_personal_preference_hint = /** @type {(inputs: Exercise_Personal_Preference_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El plan y los cambios de ejercicio lo ponen primero o al final entre opciones equivalentes, nunca por encima de la seguridad ni de tu equipo.`)
};

const pt_pt2_exercise_personal_preference_hint = /** @type {(inputs: Exercise_Personal_Preference_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O plano e as trocas põem este à frente ou em último entre opções equivalentes, sem nunca passar por cima da segurança nem do teu equipamento.`)
};

const fr_fr2_exercise_personal_preference_hint = /** @type {(inputs: Exercise_Personal_Preference_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le programme et les remplacements le placent en premier ou en dernier parmi des options équivalentes, jamais au détriment de la sécurité ou de ton équipement.`)
};

const de_de2_exercise_personal_preference_hint = /** @type {(inputs: Exercise_Personal_Preference_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Plan und die Übungswechsel setzen diese Übung unter gleichwertigen Optionen nach vorne oder ans Ende, nie über Sicherheit oder deine Ausstattung hinweg.`)
};

const it_it2_exercise_personal_preference_hint = /** @type {(inputs: Exercise_Personal_Preference_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La scheda e le sostituzioni lo mettono per primo o per ultimo tra opzioni equivalenti, mai a scapito della sicurezza o della tua attrezzatura.`)
};

/**
* | output |
* | --- |
* | "The plan and the swaps put this first or last among equal options, never over safety or your equipment." |
*
* @param {Exercise_Personal_Preference_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_personal_preference_hint = /** @type {((inputs?: Exercise_Personal_Preference_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Personal_Preference_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_personal_preference_hint(inputs)
	if (locale === "es-419") return es_419_exercise_personal_preference_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_personal_preference_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_personal_preference_hint(inputs)
	if (locale === "de-DE") return de_de2_exercise_personal_preference_hint(inputs)
	if (locale === "it-IT") return it_it2_exercise_personal_preference_hint(inputs)
	return en_us2_exercise_personal_preference_hint(inputs)
});
export { exercise_personal_preference_hint as "exercise-personal.preference_hint" }